import { render, staticRenderFns } from "./activities.vue?vue&type=template&id=bee06b28"
import script from "./activities.ts?vue&type=script&lang=ts&external"
export * from "./activities.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports